import ServerSettings, {ServerSettingsFieldType} from "../../gd/settings/server-settings/server-settings";
import UserSettingsSkin from "./skin";
import UserSettingsViews from "./views/views";
import UserSettings_Navigation from "./navigation/navigation";
import UserMenuSettings from "../../manager/user/menu-settings";
import UserSettings_Debug from "./debug";
import UserSettings_QuickSearch from "./quick-search"
import UserSettings_DesktopApp from "./desktop-app";
import UserSettings_Interface from "./interface";
import UserSettings_Company from "./company/company";

// const debug = 'UserSettings'
const debug = false

const fields = {

    'skin': {
        type            : 'class',
    },

    'views': {
        type            : 'class',
    },
    'navigation': {
        type            : ServerSettingsFieldType.CLASS,
        'class'           : UserSettings_Navigation
    },

    'usersManagement': {
        type            : 'class',
    },

    'debug': {
        type            : ServerSettingsFieldType.CLASS,
        'class'           : UserSettings_Debug
    },

    'quickSearch': {
        type  : ServerSettingsFieldType.CLASS,
        class : UserSettings_QuickSearch
    },

    'interface': {
        type  : ServerSettingsFieldType.CLASS,
        class : UserSettings_Interface
    },

    'company': {
        type  : ServerSettingsFieldType.CLASS,
        class : UserSettings_Company
    },
}

// This class should replace me.clientData !!!

export default class UserSettings extends ServerSettings {

    public skin         : UserSettingsSkin
    public views        : UserSettingsViews
    public navigation   : UserSettings_Navigation       // Settings related to user navigation i.e. spaces etc
    public menu         : UserMenuSettings              // Be carefull it's very special and has own save
    public debug        : UserSettings_Debug            // Be carefull it's very special and has own save
    public quickSearch  : UserSettings_QuickSearch
    public desktopApp   : UserSettings_DesktopApp
    public interface    : UserSettings_Interface        // Misc interface settings
    public company      : UserSettings_Company          // Settings of the CURRENT company - one node per company id

    // save may be called multiple times from different places in a short period if time
    // and multiple updateClientData calls may cause unexpected settings updates on session
    // events, therefore debounceSave ensures that only one save in a period is called
    private debounceSave    : any

    constructor(config: any) {
        super(config, fields);

        debug && console.log(debug,"constructor() CONFIG=", config)

        /*
        currentBackend
            'labs'                 : self.labs,
            'presets'              : self.presets,
            'color'                : self.color,
            'layout'               : self.layout,
            'skin'                 : self.skin,
            'ftue'                 : self.firstUserExp,
            'setupDone'            : self.setupDone,
            'momentUpdatesRead'    : self.momentUpdatesRead,
            'notifications'        : self.notifications,
            'viewTemplates'        : self.viewTemplates,
            'todoLists'            : self.todoLists,
            'theme'                : self.theme,
            'rateExperience'       : self.rateExperience,
            'myWork'               : self.myWork,
            'views'                : self.views,
            'menu'                 : self.menu,
            'navigation'           : self.navigation,
            'debug'                : self.debug,
            'quickSearch'          : self.quickSearch,
            'desktopApp'           : self.desktopApp
         */

        this.skin               = new UserSettingsSkin(_.get(config,'skin'))
        this.views              = new UserSettingsViews(_.get(config,'views'))
        this.navigation         = this.initValue('navigation')
        this.menu               = new UserMenuSettings(config) // config has menu esli chto ...
        this.debug              = new UserSettings_Debug(_.get(config,'debug')) // config has menu esli chto ...
        this.quickSearch        = new UserSettings_QuickSearch(_.get(config,'quickSearch'))
        this.desktopApp         = new UserSettings_DesktopApp(_.get(config,'desktopApp'))
        this.interface          = new UserSettings_Interface(_.get(config,'interface'))
        this.company            = this.initValue('company')

        this.debounceSave = _.debounce(this._onSave, 100)

        debug && console.log("SETTINGS Object", this)
    }


    toJson() {
        // const result = {};
        const result            = gd.user.clientData
        result.skin             = this.skin.toJson()
        result.views            = this.views.toJson()
        result.navigation       = this.navigation.toJson()
        result.menu             = this.menu.toJson()
        result.debug            = this.debug.toJson()
        result.quickSearch      = this.quickSearch.toJson()

        result.desktopApp       = this.desktopApp.toJson()
        result.interface        = this.interface.toJson()

        this.valueToJson(result, 'navigation')
        this.valueToJson(result, 'company')

        return result
    }

    private _onSave = (callback?: callback) => {
        debug && console.log(debug, "save user settings", this.toJson())

        if (gd.isSharedView) return

        const request = gd.api.MyAccount.updateClientData({
            clientData: this.toJson()
        });

        request.done(()=>{
            callback && callback();
        })
    }

    save(callback?: callback) {
       this.debounceSave(callback)
    }
}
